/**
 * Chat API Service
 */

import http from '../client';
import { ENDPOINTS } from '../config';

/**
 * Get chat list (conversations)
 * @param {Object} params - Query parameters
 * @param {number} params.page
 * @param {number} params.limit
 * @returns {Promise<Object>}
 */
export const getChatList = async (params = {}) => {
  try {
    const response = await http.get(ENDPOINTS.CHAT.LIST, params);
    return response;
  } catch (error) {
    return { success: false, error: error.message };
  }
};

/**
 * Get chat messages
 * @param {string|number} chatId
 * @param {Object} params - Query parameters
 * @param {number} params.page
 * @param {number} params.limit
 * @param {string} params.before - Get messages before this timestamp
 * @returns {Promise<Object>}
 */
export const getChatMessages = async (chatId, params = {}) => {
  try {
    const response = await http.get(ENDPOINTS.CHAT.MESSAGES(chatId), params);
    return response;
  } catch (error) {
    return { success: false, error: error.message };
  }
};

/**
 * Send message
 * @param {string|number} chatId
 * @param {Object} messageData
 * @param {string} messageData.content - Message content
 * @param {string} messageData.type - Message type (text, image, file)
 * @param {Object} messageData.attachment - Attachment data
 * @returns {Promise<Object>}
 */
export const sendMessage = async (chatId, messageData) => {
  try {
    const response = await http.post(ENDPOINTS.CHAT.SEND(chatId), messageData);
    return response;
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export default {
  getChatList,
  getChatMessages,
  sendMessage
};
